import React from 'react';
import map from 'lodash/map';
import styles from './RemainingBoxes.module.css';
import { ReactComponent as SkippedSVG } from './skipped-box.svg';
import { ReactComponent as ShippedSVG } from './shipped-box.svg';
import { ReactComponent as FutureSVG } from './future-box.svg';

const ORDER_STATE = {
  shipped: 'SHIPPED',
  skipped: 'SKIPPED',
  refund: 'REFUND',
};

const boxSVGs = {
  SHIPPED: <ShippedSVG />,
  ASSIGNED: <FutureSVG />,
  FUTURE: <FutureSVG />,
  SKIPPED: <SkippedSVG />,
};

const RemainingBoxes = ({ remainingBoxes }) => {
  return (
    <div className={styles.container}>
      <h4>Remaining Boxes in My Subscription</h4>
      <div className={styles.boxContainer}>
        {map(remainingBoxes, (box) => {
          const { orderState, season } = box;
          const isSkippedBox = orderState === ORDER_STATE.skipped;
          const isPastBox = orderState === ORDER_STATE.shipped || isSkippedBox;
          if (orderState === ORDER_STATE.refund) return null;
          return (
            <div key={season}>
              {boxSVGs[orderState]}
              <p style={isPastBox ? { opacity: '0.4' } : null}>
                {isSkippedBox ? orderState : season}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RemainingBoxes;
